import { render, staticRenderFns } from "./LeaveEnrollHistory.vue?vue&type=template&id=65841954&scoped=true&"
import script from "./LeaveEnrollHistory.vue?vue&type=script&lang=js&"
export * from "./LeaveEnrollHistory.vue?vue&type=script&lang=js&"
import style0 from "./LeaveEnrollHistory.vue?vue&type=style&index=0&id=65841954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65841954",
  null
  
)

export default component.exports